import { State } from "../../../vendor_core/core/src/states/State";
import BURJackpotsView from "../view/BURJackpotsView";

export default class BURJackpotsProgressState extends State {
    public async enter() {
        super.enter();

        // Fill the jackpot tiers
        await BURJackpotsView.playJackpotsProgress();

        this.exit();
    }
}
